import type { Visit } from '../types';

export function filterVisits(list: Visit[], query: string): Visit[] {
  if (!query) return list;
  const q = query.toLowerCase();
  return list.filter((v) => {
    const name = (v.patientName || '').toLowerCase();
    const email = (v.patientEmail || '').toLowerCase();
    const phone = (v.patientPhone || '').toLowerCase();
    const type = (v.visitType || '').toLowerCase();
    return name.includes(q) || email.includes(q) || phone.includes(q) || type.includes(q);
  });
}

export function filterByDate(list: Visit[], range: string): Visit[] {
  if (range === 'all') return list;
  const now = new Date();
  let cutoff: number;
  if (range === 'today') {
    cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  } else if (range === 'week') {
    const d = new Date(now);
    d.setDate(d.getDate() - d.getDay());
    d.setHours(0, 0, 0, 0);
    cutoff = d.getTime();
  } else if (range === 'month') {
    cutoff = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
  } else {
    return list;
  }
  return list.filter((v) => (v.endedAt || v.scheduledAt || v.createdAt || 0) >= cutoff);
}
